import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STEPS = [
  {
    icon: '🗺️',
    title: 'Live charger map',
    body: 'See real-time status of EV charging stations near you. Green = working, yellow = busy, red = broken.',
  },
  {
    icon: '📋',
    title: '2-tap reporting',
    body: 'Spotted a broken charger? Report it in 2 taps and earn points. 10 reports = Premium free.',
  },
  {
    icon: '🔔',
    title: 'Smart alerts',
    body: 'Save chargers on your route. Get a push notification the moment their status changes.',
  },
  {
    icon: '🏆',
    title: 'Community leaderboard',
    body: 'Compete with EV drivers globally. Top reporters get the Community Hero badge.',
  },
];

export default function OnboardingPage() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const finish = () => {
    localStorage.setItem('cs_onboarded', '1');
    navigate('/');
  };

  const s = STEPS[step];
  const isLast = step === STEPS.length - 1;

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '24px 20px',
      fontFamily: 'Inter, sans-serif',
    }}>
      {/* Logo */}
      <div style={{ marginBottom: 48, display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{
          width: 32, height: 32, borderRadius: 9,
          background: 'linear-gradient(135deg, #00D4AA, #0099FF)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
        }}>⚡</div>
        <span style={{ fontWeight: 700, fontSize: 18, color: 'var(--text-1)' }}>
          Charge<span style={{ color: 'var(--teal)' }}>Sure</span>
        </span>
      </div>

      {/* Card */}
      <div style={{
        width: '100%', maxWidth: 400,
        background: 'var(--slate)', border: '1px solid var(--border)',
        borderRadius: 20, padding: '40px 32px', textAlign: 'center',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Glow */}
        <div style={{
          position: 'absolute', top: -60, left: '50%', transform: 'translateX(-50%)',
          width: 200, height: 200, borderRadius: '50%',
          background: 'var(--teal)', opacity: 0.06, filter: 'blur(40px)',
          pointerEvents: 'none',
        }} />

        <div style={{ fontSize: 64, marginBottom: 24 }}>{s.icon}</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-1)', marginBottom: 12, letterSpacing: '-0.4px' }}>
          {s.title}
        </h2>
        <p style={{ fontSize: 15, color: 'var(--text-2)', lineHeight: 1.65, marginBottom: 36 }}>
          {s.body}
        </p>

        {/* Dots */}
        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginBottom: 28 }}>
          {STEPS.map((_, i) => (
            <div key={i} onClick={() => setStep(i)} style={{
              width: i === step ? 20 : 6, height: 6, borderRadius: 3, cursor: 'pointer',
              background: i === step ? 'var(--teal)' : 'var(--border-2)',
              transition: 'width 0.25s ease, background 0.25s ease',
            }} />
          ))}
        </div>

        <button
          onClick={() => isLast ? finish() : setStep(s => s + 1)}
          style={{
            width: '100%', padding: '13px 0', borderRadius: 12, border: 'none',
            background: 'var(--teal)', color: 'var(--navy)',
            fontWeight: 700, fontSize: 15, cursor: 'pointer',
          }}
        >
          {isLast ? 'Open Map' : 'Next'}
        </button>

        {!isLast && (
          <button onClick={finish} style={{
            marginTop: 12, background: 'none', border: 'none',
            color: 'var(--text-3)', fontSize: 13, cursor: 'pointer', padding: '6px 0',
          }}>
            Skip intro
          </button>
        )}
      </div>
    </div>
  );
}
